module.exports = __webpack_public_path__ + "images/frontpage_undo@2x.png?50cc7593";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/frontpage_undo@2x.png
// module id = 667
// module chunks = 7